module.exports = __webpack_public_path__ + "static/img/04.da2498c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/04.png
// module id = 6niX
// module chunks = 1